// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import { CommonFragment_FloorPlanAssetFragmentDoc } from '../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type PlanStepQueryVariables = Types.Exact<{
  communityId: Types.Scalars['ID'];
  structureId: Types.Scalars['ID'];
}>;


export type PlanStepQuery = { __typename?: 'Query', productOfferings: { __typename?: 'ProductOfferingsPageResult', entities: Array<{ __typename?: 'ProductOffering', id: string, name: string, description?: string | null | undefined, floorPlanAssets: Array<{ __typename?: 'ReadyPlanAsset', id: string, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }>, planPackage: { __typename?: 'PlanPackage', id: string, name: string, description?: string | null | undefined }, baseConfig?: { __typename?: 'ProductOfferingConfig', id: string, name: string, salesPriceInCents?: number | null | undefined } | null | undefined, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, rendering?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined } | null | undefined }> }, structure: { __typename?: 'Structure', id: string, canChangeProductOffering: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string } | { __typename?: 'PlanPackage', id: string } | { __typename?: 'DesignPackage', id: string } | { __typename?: 'ProductOffering', id: string } | null | undefined } | null | undefined, parent: { __typename?: 'Lot', id: string, buildablePlans: Array<{ __typename?: 'ProductOffering', id: string }> } } };

export type PlanStep_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, name: string, description?: string | null | undefined, floorPlanAssets: Array<{ __typename?: 'ReadyPlanAsset', id: string, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }>, planPackage: { __typename?: 'PlanPackage', id: string, name: string, description?: string | null | undefined }, baseConfig?: { __typename?: 'ProductOfferingConfig', id: string, name: string, salesPriceInCents?: number | null | undefined } | null | undefined, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, rendering?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined } | null | undefined };

export type PlanStep_BaseConfigFragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, salesPriceInCents?: number | null | undefined };

export type PlanStep_ProgramDataFragment = { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined };

export type PlanStep_AssetFragment = { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined };

export type PlanStep_StructureFragment = { __typename?: 'Structure', id: string, canChangeProductOffering: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string } | { __typename?: 'PlanPackage', id: string } | { __typename?: 'DesignPackage', id: string } | { __typename?: 'ProductOffering', id: string } | null | undefined } | null | undefined, parent: { __typename?: 'Lot', id: string, buildablePlans: Array<{ __typename?: 'ProductOffering', id: string }> } };

export const PlanStep_BaseConfigFragmentDoc = gql`
    fragment PlanStep_BaseConfig on ProductOfferingConfig {
  id
  name
  salesPriceInCents
}
    `;
export const PlanStep_ProgramDataFragmentDoc = gql`
    fragment PlanStep_ProgramData on ProgramData {
  id
  bedrooms
  halfBaths
  fullBaths
  sellableSqft
}
    `;
export const PlanStep_AssetFragmentDoc = gql`
    fragment PlanStep_Asset on Asset {
  id
  contentType
  largePreview: previewUrl(resizing: {width: 2500, region: FULL})
}
    `;
export const PlanStep_ProductOfferingFragmentDoc = gql`
    fragment PlanStep_ProductOffering on ProductOffering {
  id
  name
  description
  floorPlanAssets {
    ...CommonFragment_FloorPlanAsset
  }
  planPackage {
    id
    name
    description
  }
  baseConfig {
    ...PlanStep_BaseConfig
  }
  minProgramData {
    ...PlanStep_ProgramData
  }
  maxProgramData {
    ...PlanStep_ProgramData
  }
  rendering {
    ...PlanStep_Asset
  }
}
    ${CommonFragment_FloorPlanAssetFragmentDoc}
${PlanStep_BaseConfigFragmentDoc}
${PlanStep_ProgramDataFragmentDoc}
${PlanStep_AssetFragmentDoc}`;
export const PlanStep_StructureFragmentDoc = gql`
    fragment PlanStep_Structure on Structure {
  id
  canChangeProductOffering {
    allowed
    disabledReasons {
      message
    }
  }
  readyPlanConfig {
    id
    readyPlan {
      id
    }
  }
  parent {
    id
    buildablePlans {
      id
    }
  }
}
    `;
export const PlanStepDocument = gql`
    query PlanStep($communityId: ID!, $structureId: ID!) {
  productOfferings(
    filter: {project: [$communityId], status: ACTIVE, showInCheckout: true, isCheckout: true, type: [SFH]}
  ) {
    entities {
      ...PlanStep_ProductOffering
    }
  }
  structure(id: $structureId) {
    ...PlanStep_Structure
  }
}
    ${PlanStep_ProductOfferingFragmentDoc}
${PlanStep_StructureFragmentDoc}`;

/**
 * __usePlanStepQuery__
 *
 * To run a query within a React component, call `usePlanStepQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanStepQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function usePlanStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanStepQuery, PlanStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanStepQuery, PlanStepQueryVariables>(PlanStepDocument, options);
      }
export function usePlanStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanStepQuery, PlanStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanStepQuery, PlanStepQueryVariables>(PlanStepDocument, options);
        }
export type PlanStepQueryHookResult = ReturnType<typeof usePlanStepQuery>;
export type PlanStepLazyQueryHookResult = ReturnType<typeof usePlanStepLazyQuery>;
export type PlanStepQueryResult = Apollo.QueryResult<PlanStepQuery, PlanStepQueryVariables>;